export const getUnsoldQuantity = (quantity, bookedQuantity) => quantity - bookedQuantity
